// extracted by mini-css-extract-plugin
module.exports = {"root":"WithPopperPaperNestedActions_root__WPD8L","icon":"WithPopperPaperNestedActions_icon__2MiUZ"};